import { Link } from 'react-router-dom';

export default function HomeFooter() {
  return (
    <footer className="relative bg-[#4D1815] py-20 px-6 md:px-16 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/44480391e480b28234fb56c7639faa2e.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10">
          {/* Logo */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <img
              src="https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/59cfd97b3dc3ca96c63739e63b4f628a.jpeg"
              alt="Gucci Beauty"
              className="h-12 w-auto object-contain"
            />
            <p
              className="text-[#EADDCC]/60 text-xs"
              style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.2em' }}
            >
              THE BEAST WITHIN
            </p>
          </div>

          {/* Nav links */}
          <div className="flex flex-wrap justify-center gap-8">
            {[
              { label: 'HOME', path: '/' },
              { label: 'CAMPAIGN CONCEPT', path: '/campaign-concept' },
              { label: 'STOREFRONT', path: '/storefront' },
              { label: 'INTERACTIVE', path: '/interactive' },
            ].map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-[#EADDCC]/60 text-xs tracking-widest hover:text-[#EADDCC] transition-colors duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.25em' }}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#EADDCC]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            className="text-[#EADDCC]/30 text-xs"
            style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.1em' }}
          >
            &copy; 2025 GUCCI BEAUTY. ALL RIGHTS RESERVED.
          </p>
          <p
            className="text-[#EADDCC]/30 text-xs italic"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            instinct · desire · tension · duality
          </p>
        </div>
      </div>
    </footer>
  );
}
